import { ContextStore } from 'bernie-core';
import { getBexApiContext } from 'bernie-graphql';

import { getDateRangeInput } from 'stores/adapters/bex-api/common/search-input-adapter';
import { getRooms } from 'stores/adapters/bex-api/common/search-input-adapter';

import { AdditionalHeaderInput, PropertyInfoDetails, PropertyInfoOffersBexFeatures } from '__generated__/api';

export const getPropertyInfoInput = (
  context: ContextStore,
  criteria: any,
  propertyId: string,
  travelAd?: any
): PropertyInfoDetails.Variables => ({
  context: getBexApiContext(context),
  propertyId,
  requestContext: {
    queryParams: getQueryString(getUpdatedCriteria(criteria, travelAd)),
    additionalHeaders: getAdditionalHeaders(context)
  }
});

export const getPropertyOffersInput = (
  context: ContextStore,
  criteria: any,
  propertyId: string,
  travelAd?: any
): PropertyInfoOffersBexFeatures.Variables => ({
  ...getPropertyInfoInput(context, criteria, propertyId, travelAd),
  dateRange: getDateRangeInput(criteria),
  roomInput: getRooms(criteria)
});

export const getUpdatedCriteria = (criteria: any, travelAd?: any): any => {
  if (travelAd) {
    const data = Object.assign({}, criteria);
    if (travelAd.testVersionOverride) {
      data.testVersionOverride = travelAd.testVersionOverride;
    }
    if (travelAd.trackingData) {
      data.trackingData = travelAd.trackingData;
    }
    if (travelAd.rank) {
      data.rank = travelAd.rank;
    }
    if (travelAd.candidateHmGuid) {
      data.candidateHmGuid = travelAd.candidateHmGuid;
    }
    if (travelAd.beaconIssued) {
      data.beaconIssued = travelAd.beaconIssued;
    }
    if (travelAd.slots) {
      data.slots = travelAd.slots;
    }
    if (travelAd.position) {
      data.position = travelAd.position;
    }
    data.isLinkOff = data.clickRedirectLinkoffTrackingUrl !== undefined || travelAd.clickRedirectLinkoffTrackingUrl !== undefined;

    return data;
  }

  return criteria;
};

export const getQueryString = (criteria: any): string => {
  const query: string[] = [];
  for (const pk in criteria) {
    if ({}.hasOwnProperty.call(criteria, pk)) {
      const pkValue = criteria[pk];
      if (pkValue && (typeof pkValue === 'string' || typeof pkValue === 'number' || typeof pkValue === 'boolean')) {
        query.push(`${encodeURIComponent(pk)}=${encodeURIComponent(pkValue)}`);
      }
    }
  }

  return query.join('&');
};

export const getAdditionalHeaders = (context: ContextStore): AdditionalHeaderInput[] => {
  if (!context) {
    return [];
  }

  const { deviceId, remoteAddress, userAgent } = context;

  return [
    deviceId && { name: 'X-MC1-GUID', value: `${context.deviceId}` },
    remoteAddress && { name: 'X-REMOTE-ADDR', value: context.remoteAddress },
    userAgent && { name: 'X-USER-AGENT', value: context.userAgent },
    { name: 'X-USER-STATE', value: (context.user && context.user.authState) || 'UNKNOWN' }
  ].filter(Boolean);
};
